"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var setup = function setup(_ref) {
  var config = _ref.config;
  if (config.featureFlags['peregrine-enabled']) {
    return {
      description: 'Create a custom policy to protect your API and meet your specific business needs.',
      flows: [{
        callout: "Available for Flex Gateway and Mule 4 policies.",
        fields: [{
          name: 'schema',
          annotation: 'Policy definition is required before uploading the implementation. [Learn about how to write policy definition files](https://docs.mulesoft.com/policies/policies-custom-flex-getting-started#create-policy-definition-files).',
          label: 'JSON Schema file',
          inputType: 'file',
          classifier: 'schema',
          extensions: ['.json'],
          required: true
        }, {
          name: 'metadata',
          label: 'Metadata file',
          inputType: 'file',
          classifier: 'metadata',
          extensions: ['.yaml'],
          required: true
        }]
      }]
    };
  }
  return null;
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map